<template>
	<shared-tag-flat-select
		placement="bottom-end"
		is-quick-filter
		hide-new
		:model-value="setup.valueAsLinkModel"
		@add="setup.updateFilter($event as ITagListItemModel)"
		@delete="setup.updateFilter($event as ITagListItemModel)">
		<o-chips
			class="pointer"
			:color="setup.valueAsLinkModel.first()?.tagColorName">
			{{ setup.valueAsLinkModel.first()?.tagName ?? $t('common.filter.byTag') }}
			<template
				v-if="modelValue?.length > 1"
				#dual>
				+{{ modelValue.length - 1 }}
			</template>
		</o-chips>
	</shared-tag-flat-select>
</template>

<script setup lang="ts">
// #region Setup
import type { SharedTagQuickFilterEmits, SharedTagQuickFilterProps } from './SharedTagQuickFilterSetup';
import SharedTagQuickFilterSetup from './SharedTagQuickFilterSetup';
const emits = defineEmits<SharedTagQuickFilterEmits>() as SharedTagQuickFilterEmits;
const props = withDefaults(defineProps<SharedTagQuickFilterProps>(), SharedTagQuickFilterSetup.defaultProps);
const setup = new SharedTagQuickFilterSetup(props, emits);
// #endregion
</script>
